module.exports = __webpack_public_path__ + "static/editorial-new-regular-4683644ec48ebc8d07e9d53d6d672113.ttf";